import React  from "react";
import { useParams } from 'react-router-dom';
import TrainingModuleForm from "./components/TrainingModuleForm";
import { Card } from "antd";

const EditTrainingModule = () => {

	const { trainingModuleId } = useParams();

	return (
	    <div>
	      <Card extra={"w-full h-full p-4"}>
			<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<TrainingModuleForm recordId={trainingModuleId} mode="edit"/>
			</div>
		  </Card>
	    </div>
    );
};

export default EditTrainingModule;